import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  BaseApiTemplateService,
  Core2Config,
} from '../../shared';
import { IntercompanyAutoPurchaseStockLocationConfigContainer } from '../../../../../../models/aggregates/intercompany'


@Injectable({
  providedIn: 'root'
})
export class IntercompanyAutoPurchaseStockLocationConfigService extends BaseApiTemplateService<IntercompanyAutoPurchaseStockLocationConfigContainer> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'intercompany/auto-purchase-stock-configs/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'intercompany/auto-purchase-stock-configs/backoffice-ep';
    this.httpClient = http;
  }
  
}
